<!--
@component
MatchesWidgetEmbedPage

Route page component for the matches-widget embed.
-->

<script lang="ts">
  import Page from '$lib/components/embeds/MatchesWidget/index.svelte';
  import { homepage } from '$pkg';

  const scheduleHref = $derived(`${homepage.replace(/\/$/, '')}/schedule/`);
</script>

<div class="st-widget-header">
  World Cup 2026
  <!-- <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
  >
    <path
      d="M0 0.666667L0.666667 0L5.54 4.87333C5.85333 5.18667 6 5.59333 6 6C6 6.40667 5.84667 6.82 5.54 7.12667L0.666667 12L0 11.3333L4.78 6.47333C5.04 6.21333 5.04 5.79333 4.78 5.53333L0 0.673334V0.666667Z"
      fill="#161616"
    />
  </svg> -->
</div>

<Page />

<div class="st-widget-footer">
  <div class="st-widget-source">Source: Reuters</div>
  <div>
    <a target="_top" href={scheduleHref}>
      Full schedule
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="5"
        height="9"
        viewBox="0 0 5 9"
        fill="none"
      >
        <path
          d="M1.01199 8.01199L0.0559998 7.08197L3.064 4.01999L0 0.95697L0.931 0L4.922 3.93799L1.01199 8.01199Z"
          fill="black"
        />
      </svg>
    </a>
  </div>
</div>

<style lang="scss">
  .st-widget-header {
    font-family: 'Curator';
    font-weight: bold;
    font-size: 20px;
    padding-top: 15px;
    border-top: 3px solid #c7caca;
    z-index: 11;
    position: relative;

    svg {
      margin-left: 5px;
    }
  }

  .st-widget-footer {
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 10;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
    line-height: normal;

    .st-widget-source {
      font-size: 12px;
      color: #9d9d9d;
      align-content: center;
    }

    a {
      font-size: 13px;
      text-decoration: none;
      text-decoration-color: var(--st-links);
      text-decoration-style: dotted;
      text-decoration-thickness: 1px;

      svg {
        margin-left: 5px;
      }
    }
  }
</style>
